/**
 * Hotfix: Intercept form submission and redirect to checkout instead.
 * Bypasses malformed form inputs causing "Cannot find variant" error.
 */
(function() {
  function applyFix() {
    // Intercept form submission
    document.addEventListener('submit', function(e) {
      const form = e.target;
      if (form.action && form.action.includes('/cart')) {
        e.preventDefault();
        e.stopPropagation();

        console.log('[school-confirm-fix] Intercepted form, redirecting to checkout');

        // Build checkout URL from form action
        const checkoutUrl = form.action.replace('/cart', '/checkout');
        console.log('[school-confirm-fix] Redirecting to:', checkoutUrl);

        window.location.href = checkoutUrl;
      }
    }, true);

    console.log('[school-confirm-fix] Form interceptor applied - will redirect to checkout');
  }

  if (document.readyState === 'complete') {
    applyFix();
  } else {
    window.addEventListener('load', applyFix);
  }
})();

/**
 * Hotfix: Override form.submit() to redirect to checkout instead.
 * Bypasses malformed form inputs causing "Cannot find variant" error.
 * Extracts school address from hidden inputs and passes to checkout.
 */
(function() {
  // Store original submit
  const originalSubmit = HTMLFormElement.prototype.submit;

  // Override submit method
  HTMLFormElement.prototype.submit = function() {
    if (this.action && this.action.includes('/cart')) {
      console.log('[school-confirm-fix] Intercepted form.submit()');
      console.log('[school-confirm-fix] Form action:', this.action);

      // Extract school address from hidden inputs
      const schoolCompany = this.querySelector('[name="attributes[school_company]"]')?.value || '';
      const schoolAddress1 = this.querySelector('[name="attributes[school_address1]"]')?.value || '';
      const schoolAddress2 = this.querySelector('[name="attributes[school_address2]"]')?.value || '';
      const schoolCity = this.querySelector('[name="attributes[school_city]"]')?.value || '';
      const schoolPostcode = this.querySelector('[name="attributes[school_postcode]"]')?.value || '';
      const schoolCountry = this.querySelector('[name="attributes[school_country]"]')?.value || '';
      const schoolProvince = this.querySelector('[name="attributes[school_province]"]')?.value || '';

      console.log('[school-confirm-fix] School:', schoolCompany, schoolCity, schoolPostcode);

      // Build checkout URL with shipping address
      let checkoutUrl = '/checkout';

      if (schoolCompany || schoolPostcode) {
        const params = new URLSearchParams();
        params.set('checkout[shipping_address][company]', schoolCompany);
        params.set('checkout[shipping_address][address1]', schoolAddress1);
        params.set('checkout[shipping_address][address2]', schoolAddress2);
        params.set('checkout[shipping_address][city]', schoolCity);
        params.set('checkout[shipping_address][zip]', schoolPostcode);
        params.set('checkout[shipping_address][country]', schoolCountry);
        params.set('checkout[shipping_address][province]', schoolProvince);
        checkoutUrl = '/checkout?' + params.toString();
      }

      console.log('[school-confirm-fix] Redirecting to:', checkoutUrl);
      window.location.href = checkoutUrl;
      return;
    }

    // Call original for other forms
    return originalSubmit.call(this);
  };

  console.log('[school-confirm-fix] ✅ Form submit override applied');
})();
